import '../App.css';
import MainContent from '../components/MainContent';
import { MouseEventHandler, useEffect, useRef, useState } from 'react';
import { BackButton, BackgroundStyle, BigHeading, ButtonContainer, DocumentButton, LabelContainer, LightBlueContainer, ShortBlueButton, DeleteButton, FormWhiteContainer, WhiteContainer } from '../assets/style';
import SearchInput from '../components/SearchInput';
import dayjs from 'dayjs';
import SearchDatePicker from '../components/SearchDatePicker';
import FormButton from '../components/FormButton';
import { Box, FormControl, IconButton, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { deleteIcon } from '../assets/imgs';
import axios from 'axios';
import FormInput from '../components/FormInput';
import FormDatePicker from '../components/FormDatePicker';
import React from 'react';
import FormLabel from '../components/FormLabel';
import { height, minWidth } from '@mui/system';
import FormCheckbox from '../components/FormCheckbox';
import { useLocation, useNavigate } from 'react-router';
import MapCard from '../components/MapTextCard';
import MapInputCard from '../components/MapSmallCard';
import { projectPageName } from '../components/PageName';
import { useCreateLocationMutation, useLazyGetLocationListingQuery, useLazyGetProjectByIdQuery, useUpdateLocationMutation } from '../features/project/projectSlice';
import { useTranslation } from "react-i18next";
import { useSelector } from 'react-redux';
import { selectPermissions } from '../features/auth/authSlice';
import { Permissions } from '../utils/Permissions';

const ProjectDetailPage = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const getLocation = useLocation();
    var project = getLocation?.state;
    const [selectPosition, setSelectPosition] = useState<any[]>([]);
    const [addPosition, setAddPosition] = useState(false);
    const [getProjectQuery, projectQueryResult] = useLazyGetProjectByIdQuery();
    const [getLocationListingQuery, locationListingResult] = useLazyGetLocationListingQuery();
    const [createLocation] = useCreateLocationMutation();
    const [updateLocation] = useUpdateLocationMutation();

    const permissions = useSelector(selectPermissions)

    useEffect(() => {
        handleProjectData()
    }, []);

    const handleProjectData = async () => {
        try {
            console.log("getting data, ", project?.projectId || project?.id);
            if (localStorage.accessToken) {
                await getProjectQuery(project?.projectId || project?.id)
                await getLocationListingQuery(project?.projectId || project?.id).then((res) => {
                    if (res.status == 'fulfilled') {
                        setSelectPosition(res?.data?.records)
                    }
                })
            }
        } catch (error) {
            alert('An error occurred. Please refresh (F5) or login again.');
            console.log(error);
        } finally {
        }
    };

    const handleAddLocation = () => {
        setAddPosition(true)
    };

    const addNewLocation = (newLocation: any) => {
        createLocation(newLocation)
            .then((res) => {
                if ('error' in res) {
                    console.log(res);
                    alert(`Create Location failed: ${res.error}`)
                    setAddPosition(false)
                    // setOpenConfirmationBox(false);
                }
                else {
                    setAddPosition(false)
                    // alert("Create Location Success")
                    handleProjectData()
                }
            })
    };

    const editLocation = (updatedLocation: any) => {
        updateLocation(updatedLocation)
            .then((res) => {
                if ('error' in res) {
                    console.log(res.error);
                }
                else {
                    handleProjectData()
                }
            })
    };

    return (
        <MainContent type={projectPageName}>
            <BackgroundStyle sx={{ zIndex: 0 }}>
                <LightBlueContainer>
                    <Box sx={{ display: "row" }}>
                        <BigHeading>{t("Project Detail")}</BigHeading>
                        {
                            permissions.includes(Permissions.ProjectEdit)
                            && <ShortBlueButton onClick={() => { navigate('/add-project', { state: { project: project } }); }}>{t("Edit")}</ShortBlueButton>
                        }
                    </Box>

                    <FormLabel title={t("Contract No.")} value={projectQueryResult.data?.contractNumber ? projectQueryResult.data?.contractNumber : "/"} />
                    <FormLabel title={t("Contract Name")} value={projectQueryResult.data?.contractTitle ? projectQueryResult.data?.contractTitle : "/"} />
                    <FormLabel title={t("Project No.")} value={projectQueryResult.data?.number ? projectQueryResult.data?.number : "/"} />
                    <FormLabel title={t("Project Name")} value={projectQueryResult.data?.name ? projectQueryResult.data?.name : "/"} />
                    <FormLabel title={t("Start Date")} value={projectQueryResult?.data?.startDate ? dayjs(projectQueryResult?.data?.startDate, 'DD/MM/YYYY').format('DD/MM/YYYY') : "/"} />
                    <FormLabel title={t("End Date")} value={projectQueryResult?.data?.endDate ? dayjs(projectQueryResult?.data?.endDate, 'DD/MM/YYYY').format('DD/MM/YYYY') : "/"} />
                    <FormLabel title={t("Project Company")} value={projectQueryResult?.data?.companyName ? projectQueryResult?.data?.companyName : "/"} />
                    <FormLabel title={t("Project Manager")} value={projectQueryResult?.data?.manager ? projectQueryResult?.data?.manager : "/"} />
                    <FormLabel title={t("Tel")} value={projectQueryResult?.data?.telephone ? projectQueryResult?.data?.telephone : "/"} />
                    <FormLabel title={t("Last Updated At")} value={projectQueryResult?.data?.lastUpdatedAt ? projectQueryResult?.data?.lastUpdatedAt : "/"} />
                    <FormLabel title={t("Last Updated By")} value={projectQueryResult?.data?.lastUpdatedBy ? projectQueryResult?.data?.lastUpdatedBy : "/"} />
                    {/* <FormLabel title={"Alert"} value={projectQueryResult?.data?.alert ? "Yes" : "None"} /> */}

                    <BigHeading>{t("Project Location")}</BigHeading>
                    <Box>
                        {
                            permissions.includes(Permissions.LocationEdit)
                            && <ShortBlueButton onClick={handleAddLocation}>{t("Add New Location")}</ShortBlueButton>
                        }
                        {/* <ShortBlueButton onClick={() => { navigate('/project-request-form', { state: { project } }); }}>Edit</ShortBlueButton> */}
                    </Box>
                    <Box sx={{ marginLeft: "20px", display: "flex", flexWrap: "wrap" }}>
                        {addPosition && <MapInputCard onAddLocation={addNewLocation} isInputMode={true} setAddPosition={setAddPosition} projectId={project?.projectId || project?.id} />}
                        {selectPosition != null ? (
                            selectPosition.map((position) => (
                                <Box key={position.id}>
                                    <MapInputCard selectPosition={position} onEditLocation={editLocation} projectId={project?.projectId || project?.id} project={projectQueryResult?.data} />
                                </Box>
                            ))
                        ) : ""
                        }
                    </Box>
                    &nbsp;
                    <Box sx={{ display: "row" }}>
                        <BackButton onClick={() => { navigate('/project') }}>{t("Back")}</BackButton>
                    </Box>
                    &nbsp;
                </LightBlueContainer>
            </BackgroundStyle>
        </MainContent>
    );
};

export default ProjectDetailPage;